import { render, staticRenderFns } from "./Product1102001000011ogauc.vue?vue&type=template&id=64689814"
import script from "./Product1102001000011ogauc.vue?vue&type=script&lang=js"
export * from "./Product1102001000011ogauc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64689814')) {
      api.createRecord('64689814', component.options)
    } else {
      api.reload('64689814', component.options)
    }
    module.hot.accept("./Product1102001000011ogauc.vue?vue&type=template&id=64689814", function () {
      api.rerender('64689814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product1102001000011ogauc.vue"
export default component.exports